import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { exportRowsToCsv, exportRowsToExcel } from '../../../../../helpers/export-helper';

export const RecordsListHeaderActions = () => {
    const { visibleRecords } = useSelector((state) => state.ui);
    const [isExportOpen, setIsExportOpen] = useState(false);

    const exportRows = Array.isArray(visibleRecords) ? visibleRecords : [];
    const exportColumns = [
        { key: 'createdDate', header: 'Fecha' },
        { key: 'method', header: 'Método' },
        { key: 'functionName', header: 'Función' },
        { key: 'message', header: 'Mensaje' },
        { key: 'userDisplay', header: 'Usuario' },
    ];

    const getNormalizedRows = () => {
        return exportRows.map((record) => ({
            createdDate: record.createdDate
                ? new Date(record.createdDate).toLocaleString('es-MX', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit',
                })
                : '',
            method: record.method || '',
            functionName: record.functionName || '',
            message: record.message || '',
            userDisplay: record.userDisplay || '',
        }));
    };

    const handleDownloadCsv = () => {
        const rows = getNormalizedRows();
        exportRowsToCsv({
            rows,
            columns: exportColumns,
            baseFileName: 'records_info_visibles',
        });
        setIsExportOpen(false);
    };

    const handleDownloadExcel = () => {
        const rows = getNormalizedRows();
        exportRowsToExcel({
            rows,
            columns: exportColumns,
            baseFileName: 'records_info_visibles',
            sheetName: 'RecordsINFO',
        });
        setIsExportOpen(false);
    };

    const handleDocumentClick = (event) => {
        const exportDropdown = event.target.closest('.dropdown');
        if (!exportDropdown) {
            setIsExportOpen(false);
        }
    };

    const handleExportClick = () => {
        setIsExportOpen(!isExportOpen);
    };

    React.useEffect(() => {
        document.addEventListener('click', handleDocumentClick);
        return () => {
            document.removeEventListener('click', handleDocumentClick);
        };
    }, []);

    return (
        <div className="page-header-right ms-auto">
            <div className="page-header-right-items">
                <div className="d-flex align-items-center gap-2 page-header-right-items-wrapper">
                    <div className="dropdown">
                        <button type="button" className="btn btn-icon btn-light-brand" data-bs-toggle="dropdown" data-bs-offset="0, 10" data-bs-auto-close="outside" aria-expanded="false" onClick={handleExportClick}>
                            <i className="feather-paperclip"></i>
                        </button>
                        <div className={`dropdown-menu dropdown-menu-end ${isExportOpen ? 'show' : ''}`}>
                            <button type="button" className="dropdown-item d-flex align-items-center gap-2" onClick={handleDownloadCsv} disabled={exportRows.length === 0}>
                                <i className="feather-file"></i>
                                <span>CSV</span>
                            </button>
                            <button type="button" className="dropdown-item d-flex align-items-center gap-2" onClick={handleDownloadExcel} disabled={exportRows.length === 0}>
                                <i className="feather-grid"></i>
                                <span>Excel</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
